import { motion } from "framer-motion";
import { Mail, ShieldCheck, Inbox, CheckCircle2, Clock } from "lucide-react";

const STEPS = [
  "Securely connect Ayaan's Neev email with Google sign-in",
  "The app reads new homework, notices and circulars",
  "AI turns them into tasks, dates and notes automatically",
];

export default function GmailSync() {
  return (
    <div className="max-w-2xl">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-rose-500 to-orange-500 p-8 text-white mb-6">
        <div className="absolute -right-10 -top-10 w-52 h-52 bg-white/10 rounded-full blur-2xl" />
        <div className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center mb-4">
          <Mail className="w-6 h-6" />
        </div>
        <span className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest bg-white/20 px-2.5 py-1 rounded-full">
          <Clock className="w-3 h-3" /> Coming Soon
        </span>
        <h2 className="text-2xl sm:text-3xl font-heading font-bold mt-3">Live Neev Email Sync</h2>
        <p className="text-orange-50 mt-2 max-w-md">Homework and school notices will flow straight into Ayaan's tasks and calendar — no typing needed.</p>
      </motion.div>

      <div className="bg-white rounded-2xl border border-slate-200 p-6">
        <h3 className="font-heading font-semibold text-slate-900 flex items-center gap-2 mb-4"><Inbox className="w-5 h-5 text-indigo-500" /> How it will work</h3>
        <div className="space-y-3">
          {STEPS.map((s, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-xs font-bold shrink-0">{i + 1}</div>
              <p className="text-sm text-slate-600">{s}</p>
            </div>
          ))}
        </div>
        <div className="mt-5 pt-5 border-t border-slate-100 flex items-start gap-3">
          <ShieldCheck className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" />
          <p className="text-xs text-slate-500">
            Enabling this needs Google's app-verification (it can take a couple of weeks) and your consent to connect the account.
            When you're ready to switch it on, just say the word and we'll set it up securely.
          </p>
        </div>
      </div>

      <div className="mt-4 bg-emerald-50 border border-emerald-200 rounded-2xl p-4 flex items-start gap-3">
        <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />
        <p className="text-sm text-emerald-800">
          In the meantime, add homework under <span className="font-semibold">Tasks & Homework</span> and upload circulars in <span className="font-semibold">Documents → Common</span>.
        </p>
      </div>
    </div>
  );
}
